/* Hooks */
import useFetchSeason from './useFetchSeason';
import useFetchContent from './useFetchContent';

const requiredPropsSeason = ['episodes'];
const requiredPropsEpisode = [
  'episode.seasonNumber',
  'episode.number',
];

function getNextEpisodeIdInSeason(season, currentEpisodeId) {
  if (!season || !currentEpisodeId) return undefined;

  const { episodes } = season;
  const currentEpisodeIndex = episodes?.indexOf(currentEpisodeId);
  return episodes?.get(currentEpisodeIndex + 1);
}

export default function useNextEpisode(currentEpisode) {
  const {
    vrioAssetId: currentEpisodeId,
    episode: episodeProps,
    sourceProvider,
  } = currentEpisode || {};
  const {
    number: currentEpisodeNumber,
    seasonNumber: currentSeasonNumber,
    showId,
  } = episodeProps || {};

  const { season: currentSeason } = useFetchSeason({
    showId,
    seasonNumber: currentSeasonNumber,
    requiredProps: requiredPropsSeason,
    sourceProvider,
  });

  const nextSeasonNumber = currentSeasonNumber + 1;

  const { season: nextSeason } = useFetchSeason({
    showId,
    seasonNumber: nextSeasonNumber,
    requiredProps: requiredPropsSeason,
    sourceProvider,
  });

  const nextEpisodeIdInCurrentSeason = getNextEpisodeIdInSeason(currentSeason, currentEpisodeId);
  const nextEpisodeIdInNextSeason = nextSeason?.episodes?.get(0);

  const nextEpisodeId = nextEpisodeIdInCurrentSeason || nextEpisodeIdInNextSeason;
  const { content: nextEpisode } = useFetchContent({
    contentId: nextEpisodeId,
    requiredProps: requiredPropsEpisode,
    sourceProvider,
  });

  if (!nextEpisode) return undefined;

  const {
    seasonNumber: nextEpisodeSeasonNumber,
    number: nextEpisodeNumber,
  } = nextEpisode?.get('episode')?.toJSON() || {};

  if (currentSeasonNumber === nextEpisodeSeasonNumber) {
    if (currentEpisodeNumber + 1 === nextEpisodeNumber) {
      return nextEpisode;
    }
  } else if (currentSeasonNumber + 1 === nextEpisodeSeasonNumber && nextEpisodeNumber <= 1) {
    return nextEpisode;
  }

  return undefined;
}
